import { ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { SharedSidebarListComponent } from '../shared-sidebar-list/shared-sidebar-list.component';
/**
 *
 * Extends from NvSidebarListComponent.
 *
 */
@Component({
  selector: 'shared-sidebar-list-responsive',
  templateUrl: '../shared-sidebar-list/shared-sidebar-list.component.html',
  styleUrls: ['../shared-sidebar-list/shared-sidebar-list.scss', 'shared-sidebar-list-responsive.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SharedSidebarListResponsiveComponent extends SharedSidebarListComponent {
  @Input() styleType: 'SIDE' | 'FULL_SCREEN' = 'SIDE';

  constructor (
    public elementRef: ElementRef<HTMLElement>,
    public changeDetectorRef: ChangeDetectorRef,
  ) {
    super(changeDetectorRef);
  }

  ngOnChanges (changes: SimpleChanges) {
    if (this.styleType === 'FULL_SCREEN') {
      this.elementRef.nativeElement.classList.remove('side');
      this.elementRef.nativeElement.classList.add('full-screen');
    }
    if (this.styleType === 'SIDE') {
      this.elementRef.nativeElement.classList.remove('full-screen');
      this.elementRef.nativeElement.classList.add('side');
    }

    if (changes.listData && !changes.listData.firstChange) {
      super.ngOnChanges(changes);
    }
  }
}
